export let texts = [
    {
        "id": "design_system",
        "name":"Design System",
        "title": "Design System",
        "css": "MatcHelpTopicSpacer",
        "body": `
            Quant-UX supports the creation of design systems in four ways.

            <ol>
                <li>
                    Design Tokens
                </li>
                <li>
                    Components
                </li>
                <li>
                    Master Screens
                </li>
                <li>
                    Imports
                </li>
            </ol>

            <br>
            You can find detailed information in the next sections.
        `,
        "paragraphs": [

        ]
    }
]